import { contractConstants } from "../constants/contractConstants";

const initialState = {
  sending: false,
  addContractResponse: {},
  contractList: {},
  contractNotExecutedList: {},
  deletedContract: {},
  contractDetail: {},
  updatedContract: {},
  cloneContract:{},
  cloneContractNonExecuted:{},
  executedContract: {},
  uploadPhysicalContracts: {},
  mailStatus:{},
  error: {},
  ContractType: []
};

export default function contractReducer(state = initialState, action) {
  switch (action.type) {
    case contractConstants.ADD_CONTRACT_REQUEST:
      return {
        sending: true
      };
    case contractConstants.ADD_CONTRACT_SUCCESS:
      return {
        ...state,
        addContractResponse: action.data
      };
    case contractConstants.ADD_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case contractConstants.GET_CONTRACT_REQUEST:
      return {
        sending: true
      };
    case contractConstants.GET_CONTRACT_SUCCESS:
      return {
        ...state,
        contractList: action.data
      };
    case contractConstants.GET_CONTRACT_FAILURE:
      return {
        error: action.error
      };
    case contractConstants.GET_CONTRACT_NOT_EXECUTED_REQUEST:
      return {
        sending: true
      };
    case contractConstants.GET_CONTRACT_NOT_EXECUTED_SUCCESS:
      return {
        ...state,
        contractNotExecutedList: action.data
      };
    case contractConstants.GET_CONTRACT_NOT_EXECUTED_FAILURE:
      return {
        error: action.error
      };
    case contractConstants.DELETE_CONTRACT_REQUEST:
      return {
        sending: true
      };
    case contractConstants.DELETE_CONTRACT_SUCCESS:
      return {
        ...state,
        deletedContract: action.data
      };
    case contractConstants.DELETE_CONTRACT_FAILURE:
      return {
        error: action.error
      };
    case contractConstants.GET_CONTRACTDETAIL_REQUEST:
      return {
        sending: true
      };
    case contractConstants.GET_CONTRACTDETAIL_SUCCESS:
      return {
        ...state,
        contractDetail: action.data
      };
    case contractConstants.GET_CONTRACTDETAIL_FAILURE:
      return {
        error: action.error
      };
    case contractConstants.UPDATE_CONTRACT_REQUEST:
      return {
        sending: true
      };
    case contractConstants.UPDATE_CONTRACT_SUCCESS:
      return {
        ...state,
        updatedContract: action.data
      };
    case contractConstants.UPDATE_CONTRACT_FAILURE:
      return {
        error: action.error
      };
     case contractConstants.CLONE_CONTRACT_REQUEST:
      return {
        sending: true
      };  
    case contractConstants.CLONE_CONTRACT_SUCCESS:
      return {
        ...state,
        cloneContract: action.data
      };
    case contractConstants.CLONE_CONTRACT_FAILURE:
      return {
        error: action.error
      };
         case contractConstants.CLONE_CONTRACT_NON_EXECUTED_REQUEST:
      return {
        sending: true
      };  
    case contractConstants.CLONE_CONTRACT_NON_EXECUTED_SUCCESS:
      return {
        ...state,
        cloneContractNonExecuted: action.data
      };
    case contractConstants.CLONE_CONTRACT_NON_EXECUTED_FAILURE:
      return {
        error: action.error
      };  
    case contractConstants.POST_CONTRACTEXECUTE_REQUEST:
      return {
        sending: true
      };
    case contractConstants.POST_CONTRACTEXECUTE_SUCCESS:
      return {
        ...state,
        executedContract: action.data
      };
    case contractConstants.POST_CONTRACTEXECUTE_FAILURE:
      return {
        error: action.error
      };
     case contractConstants.POST_CONTRACTPHYSICAL_REQUEST:
      return {
        sending: true
      };
    case contractConstants.POST_CONTRACTPHYSICAL_SUCCESS:
      return {
        ...state,
        uploadPhysicalContracts: action.data
      };
    case contractConstants.POST_CONTRACTPHYSICAL_FAILURE:
      return {
        error: action.error
      };  
    case contractConstants.SEND_MAIL_REQUEST:
      return {
        sending: true
      };
    case contractConstants.SEND_MAIL_SUCCESS:
      return {
        ...state,
        mailStatus: action.data
      };
    case contractConstants.SEND_MAILFAILURE:
      return {
        error: action.error
      };
    case contractConstants.POST_CONTRACTTYPE_REQUEST:
      return {
        sending: true
      };
    case contractConstants.POST_CONTRACTTYPE_SUCCESS: 
      return {
        ...state,
        ContractType: action.data
      };
    case contractConstants.POST_CONTRACTTYPE_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/contractReducer.js